"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ExclamationTriangle: function() {
        return ExclamationTriangle;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ExclamationTriangle = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.36542 3.31085C10.4977 1.20247 13.5217 1.20356 14.6524 3.31276L22.3025 17.5827C23.3739 19.5812 21.9261 22.0001 19.6585 22.0001H4.34511C2.07656 22.0001 0.628824 19.5793 1.70212 17.5807L9.36542 3.31085ZM12.8898 4.25773C12.5128 3.55466 11.5048 3.55429 11.1274 4.25709L3.46412 18.527C3.10635 19.1932 3.58893 20.0001 4.34511 20.0001H19.6585C20.4143 20.0001 20.8969 19.1938 20.5398 18.5276L12.8898 4.25773ZM11.9999 8.0001C12.5522 8.0001 12.9999 8.44782 12.9999 9.0001V13.0001C12.9999 13.5524 12.5522 14.0001 11.9999 14.0001C11.4477 14.0001 10.9999 13.5524 10.9999 13.0001V9.0001C10.9999 8.44782 11.4477 8.0001 11.9999 8.0001ZM10.9999 17.0001C10.9999 16.4478 11.4477 16.0001 11.9999 16.0001H12.0099C12.5622 16.0001 13.0099 16.4478 13.0099 17.0001C13.0099 17.5524 12.5622 18.0001 12.0099 18.0001H11.9999C11.4477 18.0001 10.9999 17.5524 10.9999 17.0001Z",
        fill: "currentColor"
    })
}), "ExclamationTriangle");
const _default = ExclamationTriangle;
